import pois from "./pois";
var iphonePois = {
  iphone12ProMax: {
    id: "iphone12ProMax",
    name: "iPhone 12 Pro Max",
    product: true,
    html: "Iphone12ProMaxPage",
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3115,
        y: 991.35,
        z: -6343,
      },
      rotation: {
        x: 0,
        y: -90,
        z: -0,
      },
      target: "button-iphone12ProMax",
      fov: 60,
      wideFov: 41,
      interactive: false,
      clamped: true,
    },
  },
  iphone12Pro: {
    id: "iphone12Pro",
    name: "iPhone 12 Pro",
    product: true,
    html: "Iphone12ProPage",
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3115,
        y: 991.35,
        z: -5718,
      },
      rotation: {
        x: 0,
        y: -90,
        z: -0,
      },
      target: "button-iphone12Pro",
      fov: 60,
      wideFov: 41,
      interactive: false,
      clamped: true,
    },
  },
  iphone12: {
    id: "iphone12",
    name: "iPhone 12",
    product: true,
    html: "Iphone12Page",
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3115,
        y: 991.35,
        z: -5104,
      },
      rotation: {
        x: 0,
        y: -90,
        z: -0,
      },
      target: "button-iphone12",
      fov: 60,
      wideFov: 41,
      interactive: false,
      clamped: true,
    },
  },
  iphone12Mini: {
    id: "iphone12Mini",
    name: "iPhone 12 mini",
    product: true,
    html: "Iphone12MiniPage",
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3115,
        y: 991.35,
        z: -4481,
      },
      rotation: {
        x: 0,
        y: -90,
        z: -0,
      },
      target: "button-iphone12Mini",
      fov: 60,
      wideFov: 41,
      interactive: false,
      clamped: true,
    },
  },
};
export default iphonePois;